<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "Facilities",
    data() {
        return {
            msg: 'Facilities Here',
        }
    },
}
</script>

<style scoped>

</style>
